<style scoped lang="less">
  .group {
    border: 1px solid #dedede;
    padding: 5px;
    transition: all .3s;
    border-radius: 5px;
    cursor: pointer;
    height: 100%;
    display: flex;
    flex-direction: column;
    &.active {
      border-color: #2E6BE5;
    }
    .title {
    }
    & + .group {
      margin-top: 20px;
    }
  }
  .group-table {
    flex: 1;
    height: 0;
    position: relative;
  }
  .md-name {
    font-size: 14px;
    color: #606266;
  }
  .md-type {
    color: #9ea7b4;
    font-size: 12px;
  }
  .group-name {
    border-bottom: 1px solid #EEE;
    margin-top: 5px;
    margin-left: 5px;
    margin-bottom: 10px;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
  }
</style>

<template>
  <!-- 输液 -->
  <div>
    <div class="group" :class="{active: activeIndex === groupIndex}" v-for="(item, groupIndex) in groups" :key="groupIndex" @click="activeIndex = groupIndex">
      <div class="title">
        <div class="group-name">
          组{{groupIndex + 1}} <fm-btn style="margin-left: 10px;" size="small" @click="delGroup(groupIndex)">删除该组</fm-btn>
        </div>
        <fm-form inline label-alone label-align="left">
          <fm-form-item label="用法">
            <fm-select v-model="item.instructions" @change="item.setMedicineUsage()" clearable filterable placeholder="请选择用法">
              <fm-option v-for="(t, i) in usage" :key="i" :value="t" :label="t"></fm-option>
            </fm-select>
          </fm-form-item>
          <fm-form-item label="用药频率">
            <fm-select v-model="item.usageFrequency" @change="item.setUsageFrequency()" clearable filterable placeholder="请选择用药频率">
              <fm-option v-for="(t, i) in usageFrequency" :key="i" :value="t" :label="t"></fm-option>
            </fm-select>
          </fm-form-item>
          <fm-form-item label="滴速">
            <fm-input-number :min="1" style="width: 100px" v-model="item.dripSpeed[0]"></fm-input-number>
            <fm-select text style="width: 100px;margin-left: 5px;" v-model="item.dripSpeed[1]" clearable filterable placeholder="">
              <fm-option v-for="(t, i) in drippingSpeed" :key="i" :value="t.value" :label="t.label"></fm-option>
            </fm-select>
          </fm-form-item>
          <fm-form-item label="起始日期">
            <FmDatePicker style="width: 120px" :value="item.startTime" @change="(start) => {item.startTime = start;}" placeholder="请选择生日" format="Y-M-D"></FmDatePicker>
          </fm-form-item>
          <fm-form-item label="连续天数">
            <fm-input-number style="width: 80px" :min="0" v-model="item.dayNum"></fm-input-number>
          </fm-form-item>
        </fm-form>
      </div>
      <div class="group-table" ref="table">
        <Table :height="tableHeight" :columns="columns" :data="item.list" no-data-text="暂无数据">
          <div slot="mdinfo" slot-scope="{ row }">
            <div class="md-name">{{row.medichine.mainbodyMedicine ? row.medichine.mainbodyMedicine.medicineName : row.medichine.name}}</div>
            <div class="md-type">{{row.medichine.mainbodyMedicine ? row.medichine.mainbodyMedicine.medicineManufacturer : row.medichine.manufacturer}}</div>
          </div>
          <div slot="volume" slot-scope="{ row, index }">
            <fm-input-number :min="1" size="small" @input="v => {$set(item.list[index], 'volume', v); $set(item.list[index], 'amount', (row.volume * row.price).toFixed(2))}" v-model="row.volume" />
          </div>
          <div slot="amount" slot-scope="{ row }">{{row.amount}}</div>
          <div slot="timesVolume" slot-scope="{ row, index }" style="display: flex;align-items: center;">
            <fm-input-number :min="0" size="small" style="width: 80px;" @input="v => $set(item.list[index].timesVolume, 0, v)" v-model="row.timesVolume[0]" />
            <fm-select style="width: 80px;margin-left: 5px;" clearable filterable v-model="row.timesVolume[1]" @change="v => $set(item.list[index].timesVolume, 1, v)">
              <fm-option v-for="(t, i) in measurement" :key="i" :label="t" :value="t"></fm-option>
            </fm-select>
          </div>
          <div slot="skinTest" slot-scope="{ row, index }">
            <fm-switch size="mini" true-value="是" false-value="否" v-model="row.skinTest" @change="v => $set(item.list[index], 'skinTest', v)"></fm-switch>
          </div>
          <origin slot="origin" slot-scope="{ row }" :data="row.origin" />
          <div slot="action" slot-scope="{ index }">
            <fm-btn @click="delMedichine(index)" size="small">删除</fm-btn>
          </div>
        </Table>
      </div>
    </div>
    <div style="margin-top: 10px;display: flex; justify-content: flex-end;">
      <fm-btn @click="addGroup" size="small">添加新组</fm-btn>
    </div>
  </div>
</template>

<script>
import TableMixins from './mixins'

export default {
  mixins: [TableMixins],
  computed: {
    columns () {
      return [
        { title: '序号', type: 'index', width: 70, fixed: 'left' },
        { title: '药品名称', key: 'mdinfo', slot: 'mdinfo', fixed: 'left', width: 185 },
        { title: '开药量', key: 'volume', slot: 'volume', width: 130 },
        { title: '单价（元）', key: 'price', width: 120 },
        { title: '金额（元）', key: 'amount', width: 120 },
        { title: '单次剂量', key: 'timesVolume', slot: 'timesVolume', width: 200 },
        { title: '是否皮试', key: 'skinTest', width: 100, slot: 'skinTest' },
        { title: '来源', key: 'origin', fixed: 'right', slot: 'origin', width: 100 },
        { title: '操作', key: 'action', slot: 'action', width: 70, fixed: 'right' }
      ]
    }
  }
}
</script>
